import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Color, Size } from '../../const'
import WrapperLink from './WrapperLink'

const Pager = ({ link, page, max }) => {
  page = Number(page)
  max = Number(max)
  if (page > max) {
    page = 1
  }

  if (max <= 5) {
    const links = []
    links.push(<PagerLink />)
    for (let i = 1; i <= max; i++) {
      links.push(
        <PagerLinkArea>
          <LinkParts link={link} current={page} page_num={i} />
        </PagerLinkArea>
      )
    }

    return <PagerArea num={max}>{links}</PagerArea>
  } else {
    let median = page
    if (page < 3) {
      median = 3
    } else if (max < page + 2) {
      median = max - 2
    }

    let first_link = (
      <PagerButtonArea prev>
        <PagerButton prev>
          <LinkParts link={link} current={page} page_num={page - 1} link_name="前のページ" />
        </PagerButton>
      </PagerButtonArea>
    )
    let last_link = (
      <PagerButtonArea next>
        <PagerButton next>
          <LinkParts link={link} current={page} page_num={page + 1} link_name="次のページ" />
        </PagerButton>
      </PagerButtonArea>
    )
    if (median === 3) {
      first_link = (
        <PagerLinkArea prev>
          <LinkParts link={link} current={page} page_num={median - 2} />
        </PagerLinkArea>
      )
    } else if (median < 3) {
      first_link = null
    }
    if (median + 2 === max) {
      last_link = (
        <PagerLinkArea next>
          <LinkParts link={link} current={page} page_num={median + 2} />
        </PagerLinkArea>
      )
    } else if (median + 2 > max) {
      last_link = null
    }

    return (
      <PagerArea num={max}>
        {first_link}
        <PagerLinkArea prev>
          <LinkParts link={link} current={page} page_num={median - 1} />
        </PagerLinkArea>
        <PagerLinkArea>
          <LinkParts link={link} current={page} page_num={median} />
        </PagerLinkArea>
        <PagerLinkArea>
          <LinkParts link={link} current={page} page_num={median + 1} />
        </PagerLinkArea>
        {last_link}
      </PagerArea>
    )
  }
}

function LinkParts({ link, current, page_num, link_name }) {
  let name = link_name
  if (!link_name) {
    name = page_num
  }

  if (current === page_num) {
    return <PagerLink>{name}</PagerLink>
  } else {
    return <PagerLink to={`${link}${page_num}`}>{name}</PagerLink>
  }
}

const getGridColumns = (props) => {
  let columns = '1fr 30px 30px 30px 1fr'
  if (props.num <= 5) {
    columns = '1fr ' + '30px '.repeat(props.num) + '1fr'
  }

  return columns
}
const PagerArea = styled.div`
  ${(props) => css`
    display: grid;
    grid-template-columns: ${getGridColumns(props)};
    text-align: center;
    align-items: center;
  `}
`
const PagerButtonArea = styled.div`
  ${(props) => css`
    text-align: ${props.prev ? 'right' : props.next ? 'left' : 'auto'};
    padding-right: ${props.prev ? '15px' : '0'};
    padding-left: ${props.next ? '15px' : '0'};
  `}
`
const PagerButton = styled.div`
  ${(props) => css`
    float: ${props.prev ? 'right' : props.next ? 'left' : 'auto'};
    color: ${Color.FONT.NORMAL};
    font-size: ${Size.FONT.BIG};
    border-radius: 45px;
    border: 1px solid #e3e3e6;
    padding: 5px 12px;
  `}
`
const PagerLinkArea = styled.div`
  ${(props) => css`
    text-align: ${props.prev ? 'right' : props.next ? 'left' : 'auto'};
    padding-right: ${props.prev ? '11px' : '0'};
    padding-left: ${props.next ? '11px' : '0'};
  `}
`
const PagerLink = styled(WrapperLink)`
  ${(props) => css`
    color: ${props.to ? Color.FONT.NORMAL : Color.FONT.CHERRY};
    font-size: ${Size.FONT.BIG};
  `}
`

Pager.propTypes = {
  link: PropTypes.string,
  page: PropTypes.number,
  max: PropTypes.number,
}

export default Pager
